import { Html } from "@custom/schema";
import React from "react";
// TODO: Style, add stories.
export function Messages(props) {
    return /*#__PURE__*/ React.createElement("div", null, buildMessages(props.messages));
}
export var buildMessages = function(messages) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, messages.map(function(message, index) {
        return /*#__PURE__*/ React.createElement(Html, {
            key: index,
            markup: message
        });
    }));
};
export var storeMessages = function(messages) {
    localStorage.setItem("messages", JSON.stringify(messages));
};
export var readMessages = function() {
    var serialized = localStorage.getItem("messages");
    localStorage.removeItem("messages");
    if (serialized) {
        try {
            var messages = JSON.parse(serialized);
            if (Array.isArray(messages) && messages.every(function(message) {
                return typeof message === "string";
            })) {
                return messages;
            }
        } catch (e) {
            return [];
        }
    }
    return [];
};
